import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

export default function Reveal({ children, delay = 0, className = "", y = 28 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [forceShow, setForceShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      const el = ref.current;
      if (!el) return;
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) setForceShow(true);
    }, 1200);
    return () => clearTimeout(t);
  }, []);

  const show = inView || forceShow;

  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y }}
      animate={show ? { opacity: 1, y: 0 } : { opacity: 0, y }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ eyebrow, title, sub, align = "left" }) {
  return (
    <Reveal className={align === "center" ? "text-center" : ""}>
      {eyebrow && (
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#c98a00]">{eyebrow}</p>
      )}
      <h2 className="mt-4 font-display text-3xl font-semibold tracking-tight text-[#111827] sm:text-4xl">{title}</h2>
      {sub && (
        <p className={`mt-4 max-w-2xl text-base leading-relaxed text-[#64748b] md:text-lg ${align === "center" ? "mx-auto" : ""}`}>
          {sub}
        </p>
      )}
    </Reveal>
  );
}
